import Tools from "./JNSTools";
class OpenAirTableStructure {
  constructor(tableName, creds) {
    this.tableName = tableName;
    this.creds = creds;
  }

  async getTableData() {
    const tableName = this.tableName;
    const creds = this.creds;

    let urlString = Tools.getInstanceUrl(creds);

    var xmlBody = Tools.getXmlBodyAuthString(creds);
    let tablePromise = new Promise(function (resolve) {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", urlString, true);
      xhr.setRequestHeader("Content-Type", "application/xml");
      xhr.responseType = "document";
      xhr.onreadystatechange = function () {
        // Call a function when the state changes.
        if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
          // Request finished. Do processing here.
          var responseObjects = xhr.responseXML.getElementsByTagName(tableName);
          if (responseObjects.length > 0) {
            var responseNodes = responseObjects[0].childNodes;
            var standFields = [];
            var custFields = [];

            for (var i = 0; i < responseNodes.length; i++) {
              var pushNode = true;
              var isDate = false;
              var tag = responseNodes[i].tagName;
              if (tag == "created" || tag == "updated" || tag == "flags") {
                // do not push any of these fields to the field list
                pushNode = false;
              } else if (responseNodes[i].childNodes.length > 0) {
                // these nodes have multiple children -- address, date
                if (responseNodes[i].childNodes[0].tagName == "Address") {
                  pushNode = false;
                  var addressNode = responseNodes[i].childNodes[0];
                  for (var x = 0; x < addressNode.childNodes.length; x++) {
                    standFields.push(
                      tag + ":" + addressNode.childNodes[x].tagName,
                    );
                  }
                }
                if (responseNodes[i].childNodes[0].tagName == "Date") {
                  isDate = true;
                }
              }
              if (pushNode) {
                var tagDisplay = tag;
                if (isDate) {
                  tagDisplay += "^";
                }
                if (tag.substring(tag.length - 3) == "__c") {
                  custFields.push(tagDisplay);
                } else {
                  standFields.push(tagDisplay);
                }
              }
            }

            let arr;
            for (var y = 0; y < 2; y++) {
              if (y === 0) {
                arr = standFields;
              } else {
                arr = custFields;
              }

              for (var h = 0; h < arr.length - 1; h++) {
                for (var j = h + 1; j < arr.length; j++) {
                  if (arr[j] == "id") {
                    arr[j] = "aaaid";
                  }

                  if (arr[h].toLowerCase() > arr[j].toLowerCase()) {
                    var tempVal = arr[h];
                    arr[h] = arr[j];
                    arr[j] = tempVal;
                  }
                }
              }
              if (arr[0] == "aaaid") {
                arr[0] = "id";
              }
            }
            resolve({ stand: standFields, cust: custFields });
          } else {
            console.log("No records found of type " + tableName);
            resolve(null);
          }
        }
      };

      xmlBody +=
        '<Read type="' +
        tableName +
        '" method="all" limit="1" enable_custom="1"></Read>';
      xmlBody += "</request>";
      xhr.send(xmlBody);
    });

    return await tablePromise;
  }

  getStandardFields() {
    return this.standardFields;
  }

  getCustomFields() {
    return this.customFields;
  }
}

export default OpenAirTableStructure;
